import { MenuItem, styled, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { HeaderLinkType } from '../Header';

const Link = styled(NavLink)(({ theme }) => ({
  textDecoration: 'none',
  '&:hover span': {
    color: theme.palette.black.main,
  },
  '&.active span': {
    color: theme.palette.accentColor.main,
  },
}));

type PropsType = HeaderLinkType & { isMenu?: boolean; onClick?: () => void };

export const HeaderLink = ({ path, title, isMenu, onClick }: PropsType) => {
  return (
    <Link to={path} onClick={onClick}>
      {isMenu ? (
        <MenuItem key={title} sx={{ minHeight: 40 }}>
          <Typography variant='navLink' component='span'>
            {title}
          </Typography>
        </MenuItem>
      ) : (
        <Typography variant='navLink' component='span'>
          {title}
        </Typography>
      )}
    </Link>
  );
};
